import styled from "styled-components";

export const StaticInstrument = styled.span`
  color: var(--color-text-default);
  font-size: var(--text-md);
  font-weight: 700;
`;
